import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import { editCommunityFailure, editCommunitySuccess } from "domains/collection/actions";
import type { EditCommunityAction } from "domains/collection/actionTypes";

export function* editCommunitySaga({ payload }: EditCommunityAction) {
  try {
    yield apiFetch(`community/${payload.id}/edit`, { method: "PUT", body: payload });
    yield put(editCommunitySuccess(payload.id));
  } catch (error) {
    logger.error(`[editCommunitySaga] Failed to edit community with ID '${payload.id}'`, error);
    yield put(editCommunityFailure(payload.id));
  }
}
